export default "__VITE_ASSET__529e83c5__"